import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Loading from "./components/Loading";

import "../css/style.css";

const Step30_Participants = () => {

    const theEvent = JSON.parse(sessionStorage.getItem("SwissFinanceWeekEvent"));
    const remarks = JSON.parse(theEvent.remarks);
    const [orderId] = useState(sessionStorage.getItem("OrderId"));
    const [order, setOrder] = useState({});
    const orderAddress = JSON.parse(localStorage.getItem("addressBodySwissFitechWeek"));
    const [bookedTickets, setBookedTickets] = useState([]);
    const [ticketTypeInfos, setTicketTypeInfos] = useState([]);

    const [countries, setCountries] = useState([]);

    const [loading, setLoading] = useState(false);
    const [resources, setResources] = useState({});
    const [token] = useState(sessionStorage.getItem("token"));
    const [validationError, setValidationError] = useState("");

    const [allowEventsPageAccessTicketTypes, setAllowEventsPageAccessTicketTypes] = useState([]);

    // fetching resources
    const { language } = useParams();

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    useEffect(() => {
        requestFormSettings();
    }, []);

    useEffect(() => {
        requestResources();
        requestCountries();
    }, [language]);

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;

        requestOrderInformation();

    }, []);

    const requestFormSettings = () => {
        axios.get(`form/formsettings`).then((res) => {
            setAllowEventsPageAccessTicketTypes(res.data.allowEventsPageAccessTicketTypes);
        });
    };

    const requestResources = () => {
        axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data.translation);
            })
            .catch((error) => console.log(error.response.data));
    };

    const requestCountries = () => {
        setLoading(true);

        axios
            .get(`${baseUrl}/Countries?languageCode=${language}`)
            .then((res) => {
                let countries = res.data;

                //first add switzerland, germany and austria
                const indexCH = countries.findIndex((c) => c.id === 176);
                const ch = countries[indexCH];
                countries.splice(indexCH, 1);

                var indexDE = countries.findIndex((c) => c.id === 229);
                const de = countries[indexDE];
                countries.splice(indexDE, 1);

                var indexAU = countries.findIndex((c) => c.id === 228);
                const au = countries[indexAU];
                countries.splice(indexAU, 1);

                countries.unshift({ id: "", name: "---------" });
                countries.unshift(au);
                countries.unshift(de);
                countries.unshift(ch);

                setCountries(countries); // Changed from res.data to countries
            })
            .catch((error) => {
                console.error(error.response.data);
                navigate(`/${language}/sessiontimeout`);
            });

        setTimeout(() => setLoading(false), 500);
    };

    const requestOrderInformation = () => {
        setLoading(true);

        axios
            .get(`${baseUrl}/ShopBasket/Order/${orderId}`)
            .then((res) => {
                setBookedTickets(res.data.tickets);
                setOrder(res.data);
                res.data.tickets.map((t) => requestTicketTypeInfo(t.ticketTypeId));

                setTimeout(() => setLoading(false), 500);
            })
            .catch((error) => {
                console.error(error.response.data);
                navigate(`/${language}/sessiontimeout`);
            });
    };

    const requestTicketTypeInfo = (ticketTypeId) => {
        axios
            .get(`${baseUrl}/TicketType/${ticketTypeId}/Infos`)
            .then((res) => {
                setTicketTypeInfos((current) => [...current, res.data.ticketTypeInfos[0]]);
            })
            .catch((error) => console.log(error.response.data));
    };

    const onClickFillUserData = (ticketId) => {

        bookedTickets.forEach(t => {

            if (t.id === ticketId) {
                t.firstname = orderAddress.firstname;
                t.lastname = orderAddress.name;
                t.function = orderAddress.function;
                t.email = orderAddress.email;
                t.company = orderAddress.company;
                t.country = orderAddress.countryId;
                t.mobile = orderAddress.mobile;
            }
        });

        setBookedTickets([...bookedTickets]);
    };

    const onInputChange = (e, ticketId) => {

        bookedTickets.forEach(t => {
            if (t.id === ticketId) {
                t[e.target.name] = e.target.value;
            }
        });

        setBookedTickets([...bookedTickets]);
    };

    // Helper function to get country ID from country name
    const getCountryIdFromName = (countryName) => {
        if (!countryName || countries.length === 0) {
            return 176; // Default to Switzerland
        }

        // If it's already a number, return it
        if (!isNaN(countryName)) {
            return parseInt(countryName);
        }

        // Find country by name
        const country = countries.find(c => c.name === countryName);
        return country ? country.id : 176; // Default to Switzerland if not found
    };

    // validating input fields - use useMemo to recalculate when bookedTickets changes
    const isFormValid = useMemo(() => {
        if (bookedTickets.length === 0) {
            return false;
        }

        return bookedTickets.every(t => {
            // Check if values exist, trim them, and validate they're not just whitespace
            const hasFirstname = t.firstname && t.firstname.trim() && /^.{1,70}$/.test(t.firstname.trim());
            const hasLastname = t.lastname && t.lastname.trim() && /^.{1,70}$/.test(t.lastname.trim());
            const hasFunction = t.function && t.function.trim() && /^.{1,70}$/.test(t.function.trim());
            const hasCompany = t.company && t.company.trim() && /^.{1,70}$/.test(t.company.trim());
            const hasEmail = t.email && t.email.trim() && /^\S+@\S+\.\S+$/.test(t.email.trim());

            return hasFirstname && hasLastname && hasFunction && hasCompany && hasEmail;
        });
    }, [bookedTickets]);

    const mapTicketsUserData = () => {

        return (
            ticketTypeInfos &&
            ticketTypeInfos.length > 0 &&
            bookedTickets &&
            bookedTickets.length > 0 &&
            bookedTickets.map(
                (bt, index) => (
                    <div key={bt.id} className="mt-5">
                        <div className="row mt-2">
                            <div className="col-md-12">
                                <span className="title-blue">Ticket {index + 1}: {ticketTypeInfos.find(tti => tti.ticketTypeId === bt.ticketTypeId).name}</span><br />
                                <span className="text-muted">Please fill out all mandatory fields</span>
                            </div>
                        </div>
                        {index === 0 &&
                            <div className="row mt-2">
                                <div className="col-md-12">
                                    <button className="btn-fill-user" onClick={() => onClickFillUserData(bt.id)}>{resources.ParticipantsGetBuyerInput}</button>
                                </div>
                            </div>
                        }
                        <div className="row mt-1">
                            <div className="col-md-6 mt-3">
                                <span>{resources.ShippingFirstName} *</span>
                                <input
                                    type="text"
                                    name="firstname"
                                    className="form-control custom-textbox"
                                    value={bt.firstname || ""}
                                    onChange={(e) => onInputChange(e, bt.id)}
                                    required
                                />
                            </div>

                            <div className="col-md-6 mt-3">
                                <span>{resources.ShippingLastName} *</span>
                                <input
                                    type="text"
                                    name="lastname"
                                    className="form-control custom-textbox"
                                    value={bt.lastname || ""}
                                    onChange={(e) => onInputChange(e, bt.id)}
                                    required
                                />
                            </div>

                            <div className="col-md-6 mt-3">
                                <span>{resources.ShippingCompany} *</span>
                                <input
                                    type="text"
                                    name="company"
                                    className="form-control custom-textbox"
                                    value={bt.company || ""}
                                    onChange={(e) => onInputChange(e, bt.id)}
                                    required
                                />
                            </div>

                            <div className="col-md-6 mt-3">
                                <span>{resources.ShippingFunction} *</span>
                                <input
                                    type="text"
                                    name="function"
                                    className="form-control custom-textbox"
                                    value={bt.function || ""}
                                    onChange={(e) => onInputChange(e, bt.id)}
                                    required
                                />
                            </div>

                            <div className="col-md-6 mt-3">
                                <span>{resources.ShippingEmail} *</span>
                                <input
                                    type="email"
                                    name="email"
                                    className="form-control custom-textbox"
                                    value={bt.email || ""}
                                    onChange={(e) => onInputChange(e, bt.id)}
                                    required
                                />
                            </div>

                            <div className="col-md-6 mt-3">
                                <span>{resources.ShippingCountry} *</span>
                                <select
                                    className="form-control custom-textbox"
                                    aria-label="Land"
                                    name="country"
                                    value={getCountryIdFromName(bt.country)}
                                    onChange={(e) => onInputChange(e, bt.id)}>
                                    {countries.map((c, index) => (
                                        <option value={c.id} key={index}>
                                            {c.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-6 mt-3">
                                <span>{resources.ShippingMobile}</span>
                                <input
                                    type="text"
                                    name="mobile"
                                    className="form-control custom-textbox"
                                    value={bt.mobile || ""}
                                    onChange={(e) => onInputChange(e, bt.id)}
                                    required
                                />
                            </div>

                            <div className="col-md-6 mt-3">
                                <span>{resources.ShippingLinkedin}</span>
                                <input
                                    type="text"
                                    name="linkedin"
                                    className="form-control custom-textbox"
                                    value={bt.linkedin || ""}
                                    onChange={(e) => onInputChange(e, bt.id)}
                                    required
                                />
                            </div>
                        </div>
                    </div>
                )
            )
        );
    }

    const addDataToTickets = () => {
        // Check validation first
        if (!isFormValid) {
            setValidationError("Please fill in all required fields.");
            return;
        }

        // Clear validation error if validation passes
        setValidationError("");

        // Retrieve existing addressBody from localStorage
        let existingAddressBody = {};
        try {
            existingAddressBody = JSON.parse(localStorage.getItem("addressBodySwissFitechWeek")) || {};
        } catch (e) {
            existingAddressBody = {};
        }

        //update ticket address
        bookedTickets.forEach((t, key, bookedTickets) => {
            // Find the country name from the countries array
            // Convert t.country to number for comparison since select values are strings
            const selectedCountry = countries.find(c => c.id === parseInt(t.country));
            const countryName = selectedCountry ? selectedCountry.name : 'Switzerland';

            // Trim all string values before submitting
            let ticketBody = {
                firstname: t.firstname?.trim() || "",
                name: t.lastname?.trim() || "",
                function: t.function?.trim() || "",
                company: t.company?.trim() || "",
                option4: t.option4?.trim() || "",
                email: t.email?.trim() || "",
                mobile: t.mobile?.trim() || "",
                country: countryName,
                option1: existingAddressBody?.code1,
                option2: existingAddressBody?.code2,
                option3: t.linkedin?.trim() || "",
            };

            axios
                .put(`${baseUrl}/Ticket/${t.id}/Address`, ticketBody)
                .then(() => {
                    if (Object.is(bookedTickets.length - 1, key)) {
                        /* redirect to events page or checkout based on ticket types */
                        navigateToEventsOrCheckout();
                    }
                })
                .catch((error) => console.log(error.response.data));
        });
    }

    const navigateToEventsOrCheckout = () => {
        // Check if any ticket has an allowed ticket type for events page access
        const hasEventsPageAccess = bookedTickets.some(ticket =>
            allowEventsPageAccessTicketTypes.includes(ticket.ticketTypeId)
        );

        if (hasEventsPageAccess) {
            navigate(`/${language}/events`);
        } else {
            if (order.totalPrice === 0) {
                changePaymentTypeToFree();
            } else {
                navigate(`/${language}/checkout`);
            }
        }
    }

    const changePaymentTypeToFree = () => {
        axios
            .put(`${baseUrl}/ShopBasket/Order/${orderId}/PaymentType/5`)
            .then(async () => {
                await confirmShopbasketByOrderId(orderId);
                navigate(`/${language}/confirmation/${orderId}`);
            });
    }

    const confirmShopbasketByOrderId = async (orderId) => {
        try {
            const res = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/Confirm`);
            return res.data;
        } catch (error) {
            console.error(error)
        }
    };

    return (
        <div>
            {loading ? (
                <>
                    <div className="d-none d-lg-block">
                        <Loading
                            alignment="center"
                            color="#d3d3d3"
                            bgColor="#fff"
                            position="fixed"
                            top="50%"
                            left="50%"
                        />
                    </div>
                    <div className="d-lg-none">
                        <Loading
                            alignment="center"
                            color="#d3d3d3"
                            bgColor="#fff"
                            position="fixed"
                            top="45%"
                            left="45%"
                        />
                    </div>
                </>
            ) : (
                <>
                    <Header />

                    {resources && (
                        <div className="container pt-0 wrapper-smaller">

                            {/* user data */}
                            {mapTicketsUserData()}

                            {/* Validation Error Message */}
                            {validationError && (
                                <div className="row mt-4">
                                    <div className="col-md-12">
                                        <div className="alert alert-danger" role="alert">
                                            <i className="bi bi-exclamation-circle-fill me-2"></i>
                                            {validationError}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* next button */}
                            <div className="row mt-5">
                                <div className="col-md-6 text-start">
                                    <button className="btn btn-custom" onClick={() => navigate(-1)}>
                                        {resources._Back}
                                    </button>
                                </div>
                                <div className="col-md-6 text-end">
                                    <button className="btn btn-custom" onClick={addDataToTickets}>
                                        {resources._Next}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="container wrapper">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <Footer language={language} />
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default Step30_Participants;